import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useSettings(fallback) {
  const [settings, setSettings] = useState(fallback);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  return settings;
}
